import { useContext } from "react";
import AppContext from "../contexts/AppContext/AppContext";

/**
 * Custom hook for using AppContext.
 * This hook simplifies the process of accessing the AppContext.
 * It abstracts the useContext call with the AppContext as argument,
 * allowing components to get the context value directly by calling this hook.
 *
 * @returns {ContextValue} The current context value for AppContext.
 */
function useAppContext() {
  return useContext(AppContext);
}

export default useAppContext;
